module.exports = __webpack_public_path__ + "img/Ingres-x-mfl.4be20cdc.png";